import script from "./Tickets.vue?vue&type=script&setup=true&lang=js"
export * from "./Tickets.vue?vue&type=script&setup=true&lang=js"

import "./Tickets.vue?vue&type=style&index=0&id=1bcc624e&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bcc624e"]])

export default __exports__